/**
 * Pure deletion guard logic for data connectors.
 *
 * Extracted from DataConnectorsTab to enable property-based testing
 * without React component overhead.
 */

/**
 * Determines whether deletion of a data connector should be blocked.
 *
 * Deletion is blocked when the connector has one or more system associations
 * (i.e., monitoring instances linked to the integration source).
 *
 * @param systemCount - The number of systems currently using the connector
 * @returns true if deletion should be blocked (systemCount > 0), false if deletion can proceed
 */
export function shouldBlockDeletion(systemCount: number): boolean {
  return systemCount > 0
}
